export default "__VITE_ASSET__sc8DTeNN__"